<template>
    <div class="e2e-container">
        <div :class="fragment.border? 'card mc-card-with-border':''">
          <div :class="computedClass" class="">
              <div v-for="(childFragment,cellIndex) in fragment.outputs"  
                  :key="cellIndex"
                  style="margin: 2px 2px 2px 2px;"
                  :fragment="childFragment"
                  :is="resolveFragmentComponentName(childFragment)">
              </div> 
          </div> 
        </div>
    </div>
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-container",
  props: ["fragment"],
  computed: {
    computedClass() {
      const direction = this.fragment.direction; // vertical|horizontal
      // const border = this.fragment.border; // true|false
      const classes = []; 
      if (direction === "horizontal") {
        classes.push("d-flex justify-content-start");
      }
      if (direction === "vertical") {
        // return ""; //"d-flex flex-column";
      } 
      return classes.join(" ");
    }
  },
  methods: {
    resolveFragmentComponentName
  }
};
</script>
 

<style scoped>
  .mc-card-with-border{
    padding: 15px 15px 5px 15px; 
  }
</style>